import request from '@/utils/request'

export function saveCustomer(data) {
    return request({
      url: 'api-v2/save-customer',
      method: 'post',
      data
    })
  }

  export function generateOtp(data) {
    return request({
      url: 'api-v2/generate-otp',
      method: 'post',
      data
    })
  }

  export function getLongLink(data) {
    return request({
      url: 'api-v2/get-long-link',
      method: 'post',
      data
    })
  }

  export function verifyOtp(data) {
    return request({
      url: 'api-v2/verify-otp',
      method: 'post',
      data
    })
  }

  export function getPartner(data) {
    return request({
      url: 'api-v2/get-partner',
      method: 'post',
      data
    })
  }
export function sendFile(data) {
  return request({
    url: 'api-v2/ocr',
    method: 'post',
    data
  })
}

export function getInforKyc(data) {
    return request({
      url: 'api-v2/get-ekyc',
      method: 'post',
      data
    })
  }

export function getFaq(data) {
    return request({
      url: 'api-v2/get-faq',
      method: 'post',
      data
    })
  }

export function registerTima(data) {
    return request({
      url: 'api-v2/tima-register',
      method: 'post',
      data
    })
  }

  export function getTimaType(data) {
    return request({
      url: 'api-v2/tima-type',
      method: 'post',
      data
    })
  }

  export function getAddressInfo(data) {
    return request({
      url: 'api-v2/address-info',
      method: 'post',
      data
    })
  }

export function getHotBlog(data) {
    return request({
      url: 'api-v2/get-hot-blog',
      method: 'post',
      data
    })
  }

export function getListBlog(data) {
    return request({
        url: 'api-v2/get-list-blog',
        method: 'post',
        data
    })
}

export function getDetailBlog(data) {
    return request({
        url: 'api-v2/get-detail-blog',
        method: 'post',
        data
    })
}

export function getNewBlog(data) {
    return request({
        url: 'api-v2/get-new-blog',
        method: 'post',
        data
    })
}

export function getReferenceBlog(data) {
    return request({
        url: 'api-v2/get-reference-blog',
        method: 'post',
        data
    })
}

export function getCategoryBlog(data) {
    return request({
        url: 'api-v2/get-category-blog',
        method: 'post',
        data
    })
}